import { parseQuantity } from "./parseQuantity";
import { findBestSlug } from "./findBestSlug";
import { convertToGrams } from "./convertToGrams";

export function parseRecipe(recipeText, foodInfo) {
  const lines = recipeText
    .split("\n")
    .map(l => l.trim())
    .filter(Boolean);

  const parsed = [];

  let totalGrams = 0;
  let totalKcal = 0;
  let totalProtein = 0;
  let totalFiber = 0;

  for (const line of lines) {
    const { amount, unit, ingredient } = parseQuantity(line);

    // 👇 CRITICAL: match ONLY ingredient text
    const match = ingredient
      ? findBestSlug(ingredient, foodInfo)
      : { slug: "COULD_NOT_FIND", name: "Unknown" };

    let grams = null;

    if (amount && unit && match.slug !== "COULD_NOT_FIND") {
      grams = convertToGrams(amount, unit, match.slug, foodInfo);
    }

    const food = foodInfo[match.slug] || {};

    if (grams) {
      if (food.kcal_per_100g) totalKcal += grams * food.kcal_per_100g / 100;
      if (food.protein_per_100g) totalProtein += grams * food.protein_per_100g / 100;
      if (food.fiber_per_100g) totalFiber += grams * food.fiber_per_100g / 100;
      totalGrams += grams;
    }

    parsed.push({
      original: line,
      amount,
      unit,
      ingredient,
      slug: match.slug,
      name: match.name,
      grams
    });
  }

  return {
    parsed_ingredients: parsed,
    totals: {
      total_grams: totalGrams,
      total_kcal: totalKcal,
      total_protein: totalProtein,
      total_fiber: totalFiber,
      kcal_per_100g: totalGrams ? totalKcal / totalGrams * 100 : null,
      protein_per_100g: totalGrams ? totalProtein / totalGrams * 100 : null,
      fiber_per_100g: totalGrams ? totalFiber / totalGrams * 100 : null
    }
  };
}
